import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=4dcfaeb0&scoped=true"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=4dcfaeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfaeb0",
  null
  
)

export default component.exports